import { Check, EyeOff } from 'lucide-react';
import { resolveToastMessage, useI18n } from '@nx/i18n';
import type { EOToast } from '../../store/slices/eoUiSlice';

interface ProfileToastHostProps {
  toasts: EOToast[];
}

export function ProfileToastHost({ toasts }: ProfileToastHostProps) {
  const { t } = useI18n();

  return (
    <div className="profile-toast-host">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`profile-toast profile-toast--${toast.kind === 'danger' ? 'danger' : 'default'}`}
        >
          {toast.kind === 'danger' ? (
            <EyeOff className="h-4 w-4" strokeWidth={2} />
          ) : (
            <Check className="h-4 w-4" strokeWidth={2} />
          )}
          <span>{resolveToastMessage(t, toast.msg, toast.params)}</span>
        </div>
      ))}
    </div>
  );
}
